var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b052a1229148594240d8ef5299fa21130dd9846a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hem-com@hem-design-studio"]={id:"b052a1229148594240d8ef5299fa21130dd9846a"};
      